/**
 * @generated SignedSource<<a6b8acbc5d5a199f01277220ad9314a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineUpdate_todoTimelineUpdate$data = {
  readonly events: ReadonlyArray<{
    readonly __typename: string;
    readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEvent_event">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEvent_timelineItem">;
  readonly " $fragmentType": "TodoTimelineUpdate_todoTimelineUpdate";
};
export type TodoTimelineUpdate_todoTimelineUpdate$key = {
  readonly " $data"?: TodoTimelineUpdate_todoTimelineUpdate$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdate_todoTimelineUpdate">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineUpdate_todoTimelineUpdate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "events",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TodoTimelineUpdateEvent_event"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoTimelineUpdateEvent_timelineItem"
    }
  ],
  "type": "TodoTimelineUpdate",
  "abstractKey": null
};

(node as any).hash = "dab9632fcb94e767fad1868593e37648";

export default node;
